import React from 'react'
import { ProductCardSmall } from './ProductCardSmall'
import { AddToCartButton } from '../components/Product/AddToCartButton'
import type { Product } from '@ztechapps/common.contract'

export type ProductCardSmallWithAddToCartProps = Product

export const ProductCardSmallWithAddToCart = ({
  coverImage,
  coverImageThumb,
  code,
  name,
  _id,
}: ProductCardSmallWithAddToCartProps) => {
  return (
    <ProductCardSmall
      {...{
        coverImage,
        coverImageThumb,
        code,
        name,
        _id,
        addToCartContent: <AddToCartButton bsSize="sm" product={{ _id, code }} />,
      }}
    />
  )
}
